"use strict";

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var merge_1 = __importDefault(require("lodash/merge"));

var introspection = function introspection(data) {
  var tmpData = {};

  if (data.notDefaultValue) {
    return tmpData;
  }

  if (data.datas) {
    data.datas.forEach(function (tmp) {
      var result = introspection(tmp);
      Object.keys(result).forEach(function (temp) {
        if ('object' === typeof temp) {
          Object.keys(temp).forEach(function (key) {
            tmpData[key] = temp[key];
          });
        } else {
          tmpData[temp] = result[temp];
        }
      });
    });
  }

  if (data.name) {
    if ('array' === data.componentType) {
      if (Object.keys(tmpData).length > 0) {
        return _defineProperty({}, data.name, [tmpData]);
      }

      return _defineProperty({}, data.name, [undefined !== data.defaultValue ? data.defaultValue : '']);
    }

    if (Object.keys(tmpData).length > 0) {
      return _defineProperty({}, data.name, tmpData);
    }

    return _defineProperty({}, data.name, undefined !== data.defaultValue ? data.defaultValue : '');
  }

  return tmpData;
};

var initializeValues = function initializeValues(data) {
  var value = {};
  var newData = data;

  if (!Array.isArray(data)) {
    newData = [data];
  }

  newData.map(introspection).forEach(function (result) {
    Object.keys(result).forEach(function (temp) {
      if (value[temp]) {
        if (undefined !== result[temp]) {
          value[temp] = (0, merge_1.default)(result[temp], value[temp]);
        }
      } else {
        value[temp] = undefined !== result[temp] ? result[temp] : '';
      }
    });
  });
  return value;
};

exports.default = initializeValues;